import React, { Component } from 'react';
import './css/App.scss';
import Main from "./org/osmap/pwcompare/main.js";

class App extends Component {
  render() {
    return (
      <div className="App">
          <Main />
      </div>
    );
  }
}

export default App;
